module.exports = __webpack_public_path__ + "img/product15.ef70e09b.jpg";